<template>
  <article class="layout-section">
    <section class="layout-section__hgroup">
      <h2 class="layout-section__heading">Veuillez remplir ce formulaire</h2>
      <p>Un membre d'une équipe vous répondra dans les plus brefs délais.</p>

      <template v-if="showValidation && !isValid">
        <p v-for="msg in errorMessages" :key="msg" class="home-form__error">{{ msg }}</p>
      </template>
    </section>

    <section v-if="isCompleted" class="home-form__section -status">
      <h2 class="layout-section__heading">Merci!</h2>
      <p>Votre message a été envoyé avec succès.</p>
    </section>

    <section v-else-if="serverError" class="home-form__section -status">
      <h2 class="layout-section__heading">Erreur d'envoi</h2>
      <p>Une erreur est survenue lors de l'envoi du message. Veuillez réessayer plus tard.</p>
    </section>

    <form v-else class="home-form" :class="{ '-sending': isSending }" @submit.prevent="onSubmit">
      <section class="home-form__section">
        <div class="home-form__fieldset">
          <input
            v-model="model.name"
            type="text"
            placeholder="Nom"
            class="input-text"
            :class="{ '-invalid': showValidation && errors.required.name }"
          />
        </div>

        <div class="home-form__fieldset">
          <input
            v-model="model.email"
            type="text"
            placeholder="Courriel"
            class="input-text"
            :class="{ '-invalid': showValidation && (errors.required.email || errors.format.email) }"
          />
        </div>
      </section>

      <section class="home-form__section">
        <input
          v-model="model.subject"
          type="text"
          placeholder="Sujet"
          class="input-text"
          :class="{ '-invalid': showValidation && errors.required.subject }"
        />
      </section>

      <section class="home-form__section">
        <textarea
          v-model="model.message"
          placeholder="Message"
          class="input-text -textarea"
          :class="{ '-invalid': showValidation && errors.required.message }"
        />
      </section>

      <div class="home-form__section -button">
        <button type="submit" class="button -primary">Envoyer</button>
      </div>
    </form>

    <section class="layout-section__hgroup -alt-top">
      <h2 class="layout-section__heading">Coordonnées</h2>
    </section>

    <section class="layout-list">
      <div class="layout-list__item">
        <SvgIcon id="action-location" />
        <p>5000, d'Iberville, bureau 304, Montréal (Québec) H2H 2S6</p>
      </div>

      <div class="layout-list__item">
        <SvgIcon id="action-phone" />
        <p>(514) 948-2044</p>
      </div>

      <div class="layout-list__item">
        <SvgIcon id="action-mail" />
        <a href="mailto:info@icea.qc.ca">info@icea.qc.ca</a>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ContactIndex',
  data() {
    return {
      showValidation: false,
      isSending: false,
      isCompleted: false,
      serverError: false,
      labels: {
        name: 'Nom',
        email: 'Courriel',
        subject: 'Sujet',
        message: 'Message'
      },
      model: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  computed: {
    errors() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return {
        required: {
          name: !this.model.name.trim().length,
          email: !this.model.email.trim().length,
          subject: !this.model.subject.trim().length,
          message: !this.model.message.trim().length
        },
        format: {
          email: !emailPattern.test(this.model.email)
        }
      }
    },
    isValid() {
      return Object.values(this.errors.required).every(v => !v) && Object.values(this.errors.format).every(v => !v)
    },
    errorMessages() {
      const messages = []

      const requiredFields = Object.entries(this.errors.required)
        .filter(([, hasError]) => hasError)
        .map(([field]) => this.labels[field])

      if (requiredFields.length) messages.push(`Les champs suivants sont requis : ${requiredFields.join(', ')}.`)
      if (this.errors.format.email) messages.push('Le courriel n’est pas valide.')

      return messages
    }
  },
  methods: {
    onSubmit() {
      if (this.isSending || this.isCompleted) return

      if (!this.isValid) {
        this.showValidation = true
        return
      }

      this.showValidation = false
      this.isSending = true

      fetch('https://backend.icea.qc.ca/?rest_route=/wcd/v1/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.model)
      })
        .then(response => {
          this.isSending = false

          if (response.ok) {
            this.isCompleted = true
            this.model = { name: '', email: '', subject: '', message: '' }
          } else {
            this.serverError = true
          }
        })
        .catch(() => {
          this.isSending = false
          this.serverError = true
        })
    }
  }
}
</script>
